/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import { isMobileView, isTabletView, renderHelpDesc } from '../../components/utils/utils';
import EmptyFileDownloader from '../../components/EmptyFileDownloader/EmptyFileDownloader';
import ServiceCardDownloader from '../../components/ServiceCardDownloader/ServiceCardDownloader';
import { PanelStyle } from '../../constants';
import { DecisionContainer, PersonalDataContainer } from '../../containers';
import CustomizedMap from './CustomizedMap';
import history from '../../core/history';
import s from './EServices.css';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import _ from 'lodash';
import fetch from '../../core/fetch/fetch.server';
import AttachmentsPanel from '../../components/AttachmentsPanel/AttachmentsPanel';
import agentConfig from './agent';

import v from './validators';
import { ListaUrzedow } from '../urzad/ListaUrzedow';

const {
  leftCol,
  labelCol,
  inputCol,
  inputStyle,
  errorSpanStyle,
  rightCol,
  labelStyle,
  rowStyle,
} = PanelStyle;


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const AddressFormDict = {
  AddressCity: {
    label: 'Miejscowość',
    editable: true,
  },
  AddressStreet: {
    label: 'Ulica',
    editable: true,
  },
  AddressFlat: {
    label: 'Numer lokalu',
    editable: true,
  },
  AddressNumber: {
    label: 'Numer budynku',
    editable: true,
  },
  AddressZipCode: {
    label: 'Kod pocztowy',
    editable: true,
  },
};

const LandDevelDict = {
  parcelArea: {
    label: 'Powierzchnia terenu/lokalu objęta wnioskiem',
    editable: true,
  },
  buildArea: {
    label: 'Powierzchnia budynków',
    editable: true,
  },
  changeArea: {
    label: 'Powierzchnia przeznaczona do przekształcenia w wyniku realizacji inwestycji',
    editable: true,
  },
  changeDesc: {
    label: 'Opis dotychczasowego zagospodarowaniu terenu oraz projektowane zmiany',
    editable: true,
    type: 'textarea',
  },
  roadPositionDesc: {
    label: 'Usytuowanie obiektu na działce w stosunku do drogi publicznej',
    editable: true,
    type: 'textarea',
  },
};

const RoadDict = {
  roadEntry: {
    label: 'Wjazd na drogę publiczną',
    editable: true,
    type: 'textarea',
  },
  street: {
    label: 'Z ulicy',
    editable: true,
    type: 'textarea',
  },
  parking: {
    label: 'Parkowanie',
    editable: true,
    type: 'textarea',
  },
};

const IntendedBuildTypeDict = {
  BuildTypeName: {
    label: 'Opis inwestycji',
    editable: true,
  },
  BuildTypeType: {
    label: 'Przeznaczenie obiektu',
    editable: true,
  },
};

const OtherDict = {
  fieldSize: {
    label: 'Wielkość gospodarstwa rolnego w ha',
    editable: true,
  },
};

const RoofCharacteristics = {
  projectLength: {
    label: 'Długość - stan projektowany',
    editable: true,
  },
  projectWidth: {
    label: 'Szerokość - stan projektowany',
    editable: true,
  },
  projectHeigth: {
    label: 'Wysokość mierzona od poziomu terenu do gzymsu, okapu - stan projektowany',
    editable: true,
  },
  projectHeigth2: {
    label: 'Wysokość mierzona od poziomu terenu  do najwyżej położonej kalenicy lub gzymsu w przypadku dachu  płaskiego - stan projektowany',
    editable: true,
  },
  actualLength: {
    label: 'Długość - stan istniejący',
    editable: true,
  },
  actualWidth: {
    label: 'Szerokość - stan istniejący',
    editable: true,
  },
  actualHeigth: {
    label: 'Wysokość mierzona od poziomu terenu do gzymsu, okapu - stan istniejący',
    editable: true,
  },
  actualHeigth2: {
    label: 'Wysokość mierzona od poziomu terenu  do najwyżej położonej kalenicy lub gzymsu w przypadku dachu  płaskiego - stan istniejący',
    editable: true,
  },
  levelNumber: {
    label: 'Liczba kondygnacji',
    editable: true,
  },
  other: {
    label: 'Inne (np. ilość mieszkań; ilość lokali użytkowych/gabinetów; powierzchnia sprzedaży - w przypadku obiektów handlowych; ilość stanowisk remontowo/naprawczych - w przypadku obiektów warsztatowych; taras)',
    editable: true,
    type: 'textarea',
  },
  RoofType: {
    label: 'Układ połaci dachowych (jedno/dwu/ cztero wielospadowy, mansardowy, z naczółkami, z facjatami, inny)',
    editable: true,
    type: 'textarea',
  },
  RoofAngle: {
    label: 'Przybliżony kąt nachylenia połaci i rodzaj pokrycia',
    editable: true,
  },
  RoofDirection: {
    label: 'Kierunek kalenicy głównej (równolegle, prostopadle do granicy frontowej działki)',
    editable: true,
    type: 'textarea',
  },
};

const TechCharacteristics = {
  productionType: {
    label: 'Rodzaj produkcji/usług',
    editable: true,
    type: 'textarea',
  },
  productionSize: {
    label: 'Wielkość produkcji / usług',
    editable: true,
    type: 'textarea',
  },
  SalesSurface: {
    label: 'Powierzchnia sprzedaży',
    editable: true,
    type: 'textarea',
  },
  techDesc: {
    label: 'Ogólna charakterystyka procesów technologicznych',
    editable: true,
    type: 'textarea',
  },
  employmentSize: {
    label: 'Wielkość zatrudnienia',
    editable: true,
    type: 'textarea',
  },
  fireDanger: {
    label: 'Zagrożenie wybuchem lub pożarem',
    editable: true,
    type: 'textarea',
  },
  trashType: {
    label: 'Wytwarzane odpady (należy określić rodzaj odpadów i sposób ich  unieszkodliwiania)',
    editable: true,
    type: 'textarea',
  },
  Emission: {
    label: 'Wielkość emisji - substancje zanieczyszczające (należy określić ich rodzaj, gdzie będą wprowadzane)',
    editable: true,
    type: 'textarea',
  },
  energyEmission: {
    label: 'Wielkość emisji - wytwarzane energie (ciepło, hałas, wibracje, pola elektromagnetyczne)',
    editable: true,
    type: 'textarea',
  },
  environmentInfluence: {
    label: 'Czy inwestycja będzie miała znaczący negatywny wpływ na środowisko?',
    editable: true,
    type: 'textarea',
  },
};

const InfrastructureNeeds = {
  Water: {
    label: 'Woda',
    editable: true,
    type: 'textarea',
  },
  Energy: {
    label: 'Energia elektryczna',
    editable: true,
    type: 'textarea',
  },
  Sewege: {
    label: 'Odprowadzenie ścieków bytowo – gospodarczych',
    editable: true,
    type: 'textarea',
  },
  RainWater: {
    label: 'Odprowadzenie wód opadowych/deszczowych',
    editable: true,
    type: 'textarea',
  },
  Heat: {
    label: 'Zaopatrzenie w ciepło',
    editable: true,
    type: 'textarea',
  },
  Trash: {
    label: 'Sposób gromadzenia odpadów stałych',
    editable: true,
    type: 'textarea',
  },
  Gas: {
    label: 'Gaz: ',
    editable: true,
    type: 'textarea',
  },
  Other: {
    label: 'Inne potrzeby',
    editable: true,
    type: 'textarea',
  },
};

class WniosekWZ extends React.Component {
  state = {
    DecisionData: {
      AddressCity: null,
      AddressStreet: null,
      AddressFlat: null,
      AddressNumber: null,
      AddressZipCode: null,
    },
    BuildType: {
      BuildTypeName: null,
      BuildTypeType: null,
    },
    LandDevelop: {
      parcelArea: null,
      buildArea: null,
      changeArea: null,
      changeDesc: null,
      roadPositionDesc: null,
      roadEntry: null,
      street: null,
      parking: null,
    },
    InfrastructureNeeds: {
      Water: null,
      Energy: null,
      Sewege: null,
      RainWater: null,
      Heat: null,
      Trash: null,
      Gas: null,
      Other: null,
    },
    PlannedBuildCharacteristics: {
      projectLength: null,
      projectWidth: null,
      projectHeigth: null,
      projectHeigth2: null,
      actualLength: null,
      actualWidth: null,
      actualHeigth: null,
      actualHeigth2: null,
      levelNumber: null,
      other: null,
      RoofType: null,
      RoofAngle: null,
      RoofDirection: null,

      productionType: null,
      productionSize: null,
      SalesSurface: null,
      techDesc: null,
      employmentSize: null,
      fireDanger: null,
      trashType: null,
      Emission: null,
      energyEmission: null,
      environmentInfluence: null,
    },
    OtherAmounts: {
      fieldSize: null,
    },
    info: {
      agentAdd: 'NIE',
      agentName: null,
      agentAddress: null,
      agentPostOffice: null,
      agentPostalCode: null,
      agentPhoneNumber: null,
      agentMotionAddress: null,
    },
    selectedParcels: [],
    selectedRoads: [],
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    attachments: null,
    eserviceDistrict: null,
    loading: false,
    isMounted: false,
  };

  elseString = '.....................';
  spanStyle = {
    color: 'red',
  };

  validators = {
    AddressCity: [v.NotNull],
    AddressStreet: [],
    AddressFlat: [v.NotNull, v.isNumber],
    AddressNumber: [v.NotNull],
    AddressZipCode: [v.NotNull],
    BuildTypeName: [v.NotNull],
    BuildTypeType: [v.NotNull],
    parcelArea: [v.NotNull],
    buildArea: [v.NotNull],
    changeArea: [v.NotNull],
    changeDesc: [v.NotNull],
    roadPositionDesc: [v.NotNull],
    roadEntry: [v.NotNull],
    parking: [v.NotNull],
    street: [],
    Water: [v.NotNull],
    Energy: [v.NotNull],
    Sewege: [v.NotNull],
    RainWater: [v.NotNull],
    Heat: [v.NotNull],
    Trash: [v.NotNull],
    Gas: [v.NotNull],
    Other: [v.NotNull],
    projectLength: [v.NotNull],
    projectWidth: [v.NotNull],
    projectHeigth: [v.NotNull],
    projectHeigth2: [v.NotNull],
    actualLength: [v.NotNull],
    actualWidth: [v.NotNull],
    actualHeigth: [v.NotNull],
    actualHeigth2: [v.NotNull],
    levelNumber: [v.NotNull],
    other: [v.NotNull],
    RoofType: [v.NotNull],
    RoofAngle: [v.NotNull],
    RoofDirection: [v.NotNull],

    productionType: [v.NotNull],
    productionSize: [v.NotNull],
    SalesSurface: [v.NotNull],
    techDesc: [v.NotNull],
    employmentSize: [v.NotNull],
    fireDanger: [v.NotNull],
    trashType: [v.NotNull],
    Emission: [v.NotNull],
    energyEmission: [v.NotNull],
    environmentInfluence: [v.NotNull],
  };

  nextStep = '/eservices/eserviceSummary/';

  componentDidMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {

        this.setState({
          eserviceDistrict: resp
        })
      })

    this.setState({ isMounted: true });
  }

  onHide = () => this.setState({ showError: false });

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });
  setRoads = (roads, callback = null) => this.setState({ selectedRoads: roads });

  render_info = (group, key) => (
    <span>
      <b>{this.state[group][key] ? this.state[group][key] : this.elseString}</b>
    </span>
  );

  getLandDevelExplain = () => (
    <p style={{ textAlign: 'justify' }}>
      Powierzchnia przeznaczona do przekształcenia w wyniku realizacji inwestycji - powierzchnię parkingów, dróg dojazdowych, chodników, placów budowy, placów składowych, zbiorników, inne powierzchnie utwardzone czy płaty roślinności, które zostaną usunięte, a teren urządzony<br />
      Opis dotychczasowego zagospodarowaniu terenu oraz projektowane zmiany - rozbiórka obiektów istniejących, zmiana ukształtowania terenu, np. likwidacja istniejącej zieleni, zmiana istniejącej nawierzchni, przebudowa istniejącego uzbrojenia terenu lub inne
    </p>
  );

  getRoadExplain = () => (
    <p style={{ textAlign: 'justify' }}>
      Wjazd na drogę - istniejący, projektowany<br />
      Parkowanie - liczba stanowisk postojowych ogółem, w tym ilość stanowisk projektowanych; rodzaj pojazdów
    </p>
  )

  getIntendedBuildTypeExplain = () => (
    <p style={{ textAlign: 'justify' }}>
      Opis - budowa, rozbudowa lub nadbudowa obiektu budowlanego, zmiana sposobu użytkowania obiektu budowlanego lub jego części, wykonanie innych robót budowanych, zamiana sposobu użytkowania terenu. <br />
      Przeznaczenie - zabudowa mieszkaniowa jedno/wielorodzinna, usługowa, mieszkaniowo – usługowa, zagrodowa, produkcyjna.
    </p>
  );

  getInputWithError = (description, group, field) => (
    <div style={{ textAlign: 'justify' }}>
      {description}
      <input
        className="form-control"
        name={field}
        style={{
          width: '100%',
          borderColor:
            Object.keys(this.state.errors).indexOf(field) > -1 &&
              this.state.errors[field] !== null &&
              this.state.errors[field].length > 0
              ? 'red'
              : '#ccc',
        }}
        value={this.state[group][field] ? this.state[group][field] : ''}
        onChange={e => this.onChange(e, group)}
      />
      {/* RENDER ERROS IN SPAN */}
      {Object.keys(this.state.errors).indexOf(field) > -1 &&
        this.state.errors[field] !== null &&
        this.state.errors[field].length > 0
        ? this.state.errors[field].map((val, index) => (
          <span key={index} style={errorSpanStyle}>
            {val}
          </span>
        ))
        : null}
    </div>
  )

  getTextAreaWithError = (description, group, field) => (
    <p style={{ textAlign: 'justify' }}>
      {description}
      <textarea
        name={field}
        style={{
          width: '100%',
          borderColor:
            Object.keys(this.state.errors).indexOf(field) > -1 &&
              this.state.errors[field] !== null &&
              this.state.errors[field].length > 0
              ? 'red'
              : '#ccc',
        }}
        className="form-control"
        rows={10}
        value={this.state[group][field] ? this.state[group][field] : ''}
        onChange={e => this.onChange(e, group)}
      />
      {/* RENDER ERROS IN SPAN */}
      {Object.keys(this.state.errors).indexOf(field) > -1 &&
        this.state.errors[field] !== null &&
        this.state.errors[field].length > 0
        ? this.state.errors[field].map((val, index) => (
          <span key={index} style={errorSpanStyle}>
            {val}
          </span>
        ))
        : null}
    </p>
  )

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeSelect = (e, group) => {
    const name = e.state;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeAttachments = (attachments, errorMessage) => {
    const errorText = errorMessage.errorText;
    const errorTitle = errorMessage.errorTitle;
    const showError = errorMessage.showError;
    this.setState({ attachments, errorText, errorTitle, showError });
  }

  validateAttachmentsContent = () => {
    if (this.state.attachments) {
      for (const attachment of this.state.attachments) {
        if (attachment.name.length < 1) return true;
      }
    }
    return false;
  }

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ["DecisionData", "BuildType", "LandDevelop",
        "PlannedBuildCharacteristics", "OtherAmounts", "InfrastructureNeeds", 'info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  insertTestData = () => {
    this.setState({
      DecisionData: {
        AddressCity: 'test',
        AddressStreet: 'test',
        AddressFlat: 6,
        AddressNumber: 'test',
        AddressZipCode: 'test',
      },
      BuildType: {
        BuildTypeName: 'test',
        BuildTypeType: 'test',
      },
      LandDevelop: {
        parcelArea: 'test',
        buildArea: 'test',
        changeArea: 'test',
        changeDesc: 'test',
        roadPositionDesc: 'test',
        roadEntry: 'test',
        parking: 'test',
      },
      InfrastructureNeeds: {
        Water: 'test',
        Energy: 'test',
        Sewege: 'test',
        RainWater: 'test',
        Heat: 'test',
        Trash: 'test',
        Gas: 'test',
        Other: 'test',
      },
      PlannedBuildCharacteristics: {
        projectLength: 'test',
        projectWidth: 'test',
        projectHeigth: 'test',
        projectHeigth2: 'test',
        actualLength: 'test',
        actualWidth: 'test',
        actualHeigth: 'test',
        actualHeigth2: 'test',
        levelNumber: 'test',
        other: 'test',
        RoofType: 'test',
        RoofAngle: 'test',
        RoofDirection: 'test',
  
        productionType: 'test',
        productionSize: 'test',
        SalesSurface: 'test',
        techDesc: 'test',
        employmentSize: 'test',
        fireDanger: 'test',
        trashType: 'test',
        Emission: 'test',
        energyEmission: 'test',
        environmentInfluence: 'test',
      },
      OtherAmounts: {
        fieldSize: 'test',
      },
    });
  };

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (this.state.selectedParcels.length === 0) {
      this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
        loading: false,
      });
      return;
    }

    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (!this.state.attachments || this.state.attachments.length === 0) {
      this.setState({
        errorText: 'Wymagane jest dodanie załączników do składanego wniosku',
        errorTitle: 'Brak załączników.',
        showError: true,
        loading: false,
      });
      return;
    }

    const hasEmptyAttachment = this.validateAttachmentsContent();
    if (hasEmptyAttachment) {
      this.setState({
        errorText: 'Przynajmniej jeden załącznik jest pusty. Dodaj plik do załączników',
        errorTitle: 'Pusty załącznik.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (!hasFieldErrors && this.state.selectedParcels.length > 0) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          DecisionData: { ...this.state.DecisionData },
          BuildType: { ...this.state.BuildType },
          LandDevelop: { ...this.state.LandDevelop },
          PlannedBuildCharacteristics: { ...this.state.PlannedBuildCharacteristics },
          InfrastructureNeeds: { ...this.state.InfrastructureNeeds },
          info: { ...this.state.info },
          OtherAmounts: { ...this.state.OtherAmounts },
          selectedParcels: this.state.selectedParcels,
          user: {
            ...this.props.serviceInfo.user,
          },
          urzad: this.props.districts[this.props.prefix],
          attachments: this.state.attachments,
        })
        .then(resp => {
          this.redirectToSummary(resp.jobId);
        });
    }
  };

  redirectToSummary = (jobId) => {
    window.location.href = `${this.nextStep}${jobId}`;
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    const isMobile = this.state.isMounted && isMobileView(window);
    const isTablet = this.state.isMounted && isTabletView(window);
    return (
      <div style={{ paddingTop: '20px' }}>

        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user} />

        <DecisionContainer
          title={'Adres'}
          data={this.state.DecisionData}
          errors={this.state.errors}
          formDict={AddressFormDict}
          onChange={e => this.onChange(e, 'DecisionData')}
        >
          { renderHelpDesc(isMobile, isTablet) }
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
          />
        </DecisionContainer>

        {this.state.eserviceDistrict && this.state.eserviceDistrict.enableAgent ?
          <DecisionContainer
            title={'Pełnomocnik'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={agentConfig.agentInfoDict}
            onChange={e => this.onChange(e, 'info')}
            onChangeSelect={e => this.onChangeSelect(e, 'info')}
          >
            <br />
            <p style={{ fontWeight: 'bold' }}>
            W przypadku złożenia pełnomocnictwa należy uiścić opłatę skarbową w wysokości 17 zł.
            </p>
          </DecisionContainer> : null }
        {this.state.info.agentAdd === 'TAK' ?
          <DecisionContainer
            title={'Dane identyfikacyjne pełnomocnika'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={agentConfig.agentDict}
            onChange={e => this.onChange(e, 'info')}
          /> : null }

        <DecisionContainer
          title={'Rodzaj zamierzenia inwestycyjnego'}
          data={this.state.BuildType}
          errors={this.state.errors}
          explain_text={() => this.getIntendedBuildTypeExplain()}
          leftCol={'a'}
          rightCol={'a'}
          labelCol={'col-sm-6'}
          inputCol={'col-sm-6'}
          formDict={IntendedBuildTypeDict}
          onChange={e => this.onChange(e, 'BuildType')}
        />

        <DecisionContainer
          title={'1. Opis zagospodarowania terenu'}
          data={this.state.LandDevelop}
          errors={this.state.errors}
          explain_text={() => this.getLandDevelExplain()}
          formDict={LandDevelDict}
          leftCol={'a'}
          rightCol={'a'}
          labelCol={'col-sm-6'}
          inputCol={'col-sm-6'}
          onChange={e => this.onChange(e, 'LandDevelop')}
        />

        <DecisionContainer
          title={'2. Projektowany sposób obsługi komunikacyjnej'}
          data={this.state.LandDevelop}
          errors={this.state.errors}
          explain_text={() => this.getRoadExplain()}
          formDict={RoadDict}
          leftCol={'a'}
          rightCol={'a'}
          labelCol={'col-sm-6'}
          inputCol={'col-sm-6'}
          onChange={e => this.onChange(e, 'LandDevelop')}
        />

        <DecisionContainer
          title={'3. Określenie potrzeb w zakresie infrastruktury technicznej'}
          data={this.state.InfrastructureNeeds}
          errors={this.state.errors}
          formDict={InfrastructureNeeds}
          leftCol={'a'}
          rightCol={'a'}
          labelCol={'col-sm-6'}
          inputCol={'col-sm-6'}
          onChange={e => this.onChange(e, 'InfrastructureNeeds')}
        />

        <DecisionContainer
          title={'4. Opis obiektu objętego wnioskiem - gabaryty/parametry obiektu'}
          data={this.state.PlannedBuildCharacteristics}
          errors={this.state.errors}
          formDict={RoofCharacteristics}
          leftCol={'a'}
          rightCol={'a'}
          labelCol={'col-sm-6'}
          inputCol={'col-sm-6'}
          onChange={e => this.onChange(e, 'PlannedBuildCharacteristics')}
        />
        <DecisionContainer
          title={'5. Parametry techniczne inwestycji oraz dane charakteryzujące jej wpływ na środowisko'}
          data={this.state.PlannedBuildCharacteristics}
          errors={this.state.errors}
          formDict={TechCharacteristics}
          leftCol={'a'}
          rightCol={'a'}
          labelCol={'col-sm-6'}
          inputCol={'col-sm-6'}
          onChange={e => this.onChange(e, 'PlannedBuildCharacteristics')}
        />

        <DecisionContainer
          title={'6. W przypadku zabudowy zagrodowej'}
          data={this.state.OtherAmounts}
          errors={this.state.errors}
          formDict={OtherDict}
          leftCol={'a'}
          rightCol={'a'}
          labelCol={'col-sm-6'}
          inputCol={'col-sm-6'}
          onChange={e => this.onChange(e, 'OtherAmounts')}
        />

        <GrayPanel title={"Informacja dla wnioskodawcy"}>
          <div className="row">
            <div className="col-sm-12">
              <p>Do wniosku o wydanie decyzji należy załączyć:</p>
              <ul>
                <li>Poświadczoną przez właściwy organ kopię mapy zasadniczej w skali 1:500, 1:1000 (lub 1:2000 w przypadku inwestycji liniowych), przyjętej do państwowego zasobu geodezyjnego i kartograficznego obejmującej przewidywany teren, na którym będzie realizowana inwestycja oraz obejmująca obszar, na który będzie oddziaływała inwestycja;
                    <br />Mapa, o której mowa wyżej, powinna obejmować obszar wokół działki nie mniejszy niż trzykrotna szerokość frontu działki objętej wnioskiem, nie mniejszy jednak niż 50 m</li>
                <li>W przypadku braku ww. mapy zasadniczej poświadczoną przez właściwy organ kopię mapy ewidencji gruntów, przyjętej do państwowego zasobu geodezyjnego i kartograficznego obejmującej przewidywany teren, na którym będzie realizowana inwestycja oraz obejmująca obszar, na który będzie oddziaływała inwestycja; 
                  <br />Mapa, o której mowa wyżej, powinna obejmować obszar wokół działki nie mniejszy niż trzykrotna szerokość frontu działki objętej wnioskiem, nie mniejszy jednak niż 50 m,</li>
                <li>Kserokopię ww. poświadczonej przez właściwy organ kopii mapy zasadniczej (lub w przypadku jej braku mapy ewidencyjnej) z graficznym oznaczeniem granic terenu objętego wnioskiem oraz obszaru oddziaływania inwestycji</li>
                <li>Kserokopię warunków technicznych zaopatrzenia w infrastrukturę techniczną:
                  <br />◦ w wodę, odprowadzenie ścieków - warunki techniczne określone przez Oleskie Przedsiębiorstwo Wodociągów i Kanalizacji Sp. z o.o. w Oleśnie, ul. Lubliniecka 3a, 46-300 Olesno,
                  <br />◦ w energię elektryczna - warunki techniczne wraz z projektem umowy określone przez TAURON Dystrybucja S.A. Oddział w Częstochowie, Obsługa Klienta, ul. Klonowa 1, 42-700 Lubliniec,
                  <br />◦ w gaz - warunki techniczne określone przez GSG Spółka z o.o. w Zabrzu, Oddział Zakład Gazowniczy w Zabrzu, Rozdzielnia Gazu w Częstochowie, Jednostka Terenowa Eksploatacji Sieci w Oleśnie, ul. Grottgera 2, 46-300 Olesno.</li>
                <li>Dowód uiszczenia opłaty skarbowej w wysokości:
                  <br />598 zł - za wydanie decyzji o warunkach zabudowy
                  <br />UWAGA: Nie podlega opłacie skarbowej wydanie decyzji o warunkach zabudowy na wniosek właściciela lub użytkownika wieczystego terenu, którego wniosek dotyczy.
                  <br />17 zł - za dokument stwierdzający udzielenie pełnomocnictw.</li>
              </ul>
            </div>
            <div className="col-sm-12">
              <p><b>UWAGA</b></p>
              <p>Jeżeli wniosek dotyczy realizacji więcej niż jednego obiektu budowlanego, dla każdego obiektu należy przedłożyć osobną charakterystykę według pkt 4 i 5.</p>
              <p>W każdej pozycji do wypełnienia powinno znaleźć się stosowne odniesienie, w przypadku braku konieczności wpisu, stosujemy zapis „nie dotyczy”.</p>
            </div>
          </div>
        </GrayPanel>

        <AttachmentsPanel onChangeAttachments={this.onChangeAttachments} showExtraText={this.props.districts[this.props.prefix].attachmentsToEpuapEnabled}/>

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            {this.props.prefix === 'gmina_olesno_powiat_oleski' ?
              <ServiceCardDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
              : null}
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ loading: true }, () => this.startService())}
            >
              Uruchom
            </button>
            {_.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

WniosekWZ.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(WniosekWZ),
);



// WEBPACK FOOTER //
// src/routes/eservices/WniosekWZ.js